export const mobileRoutes = [
  {
    path: "/mobile",
    component: () => import("../layout/mobileLayout.vue"),
    redirect: "/mobile/home",

    children: [
      {
        path: "/mobile/home",
        name: "mobileHome",
        meta: {
          isFooter: true,
        },
        component: () => import("../views/mobile/home.vue"),
      },
      {
        path: "/mobile/great/contest",
        name: "mobileGreatContest",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/back-ground/middleSchool.vue"),
      },
      {
        path: "/mobile/news/consult",
        name: "mobileNewsConsult",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/news-consult/index.vue"),
      },
      {
        path: "/mobile/news/consult/detail",
        name: "mobileNewsConsultDetail",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/news-consult/detail.vue"),
      },
      {
        path: "/mobile/prize/winner/index",
        name: "mobilePrizeWinner",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/prize-winner/index.vue"),
      },
      {
        path: "/mobile/past/games/index",
        name: "mobilePastGames",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/past-games/index.vue"),
      },
      {
        path: "/mobile/familiarProblem/index",
        name: "mobileFamiliarProblem",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/familiarProblem/index.vue"),
      },
      {
        path: "/mobile/familiarProblem/detail",
        name: "mobileFamiliarProblemDetail",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/familiarProblem/detail.vue"),
      },
      {
        path: "/mobile/about-us/index",
        name: "mobileAboutUs",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/about-us/index.vue"),
      },
      {
        path: "/mobile/contact-us/index",
        name: "mobileContactUs",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/contact-us/index.vue"),
      },
      {
        path: "/mobile/personal-centered/index",
        name: "mobilePersonalCentered",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/personal-centered/index.vue"),
      },
      {
        path: "/mobile/personal-centered/detail",
        name: "mobilePersonalCenteredDetail",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/personal-centered/registration-detail.vue"),
      },
      {
        path: "/mobile/login",
        name: "mobileLogin",
        meta: {
          isFooter: false,
        },
        component: () => import("@/views/mobile/login/index.vue"),
      },
      {
        path: "/mobile/sign-up",
        name: "mobileSignUp",
        meta: {
          isFooter: false,
        },
        component: () => import("@/views/mobile/sign-up/index.vue"),
      },
      {
        path: "/mobile/edit/info",
        name: "mobileEditInfoMess",
        meta: {
          isFooter: false,
        },
        component: () => import("@/views/mobile/personal-centered/edit-info-mess.vue"),
      },
      {
        path: "/mobile/registration",
        name: "mobileRegistration",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/mobile/registration/index.vue"),
      },
      {
        path: "/mobile/m_wd",
        name: "m_wd",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/m_wd.vue"),
      },
      {
        path: "/mobile/MobilePreviousCompetition",
        name: "MobilePreviousCompetition",
        meta: {
          isFooter: true,
        },
        component: () => import("@/views/MobilePreviousCompetition.vue"),
      },
      {
        path: "/mobile/photo-wall",
        name: "photo-wall",
        meta: {
          //照片墙
          isFooter: true,
        },
        component: () => import("@/views/mobile/past-games/photo-wall.vue"),
      },

    ]
  },
];
